import type { FontKey } from "@/lib/fonts/registry";
import type {
  ContentLayout,
  NavbarStyle,
  SidebarCollapsible,
  SidebarVariant,
} from "./layout";
import type { ThemePreset } from "./theme";

export type PreferenceValueMap = {
  theme_preset: ThemePreset;
  font: FontKey;
  content_layout: ContentLayout;
  navbar_style: NavbarStyle;
  sidebar_variant: SidebarVariant;
  sidebar_collapsible: SidebarCollapsible;
};

export type PreferenceKey = keyof PreferenceValueMap;

export const PREFERENCE_DEFAULTS: PreferenceValueMap = {
  theme_preset: "default",
  font: "system",
  content_layout: "full-width",
  navbar_style: "sticky",
  sidebar_variant: "floating",
  sidebar_collapsible: "icon",
};
